module.exports = __webpack_public_path__ + "img/logo.ef03ae2d.png";